document.querySelectorAll('.footer-block--menu .footer-block__heading').forEach((elm) => {
  if(elm.nextElementSibling) {
    elm.nextElementSibling.setAttribute('aria-expanded', 'false');
  }

  elm.addEventListener('click', (event) => {
    let expanded = elm.nextElementSibling.getAttribute('aria-expanded') == 'false' ? 'true' : 'false';
    elm.parentElement.classList.toggle('open');
    elm.nextElementSibling.setAttribute('aria-expanded', expanded);
  });
});

function prodDescShowMoreBtn() {
  let prodDescLoadMore = document.getElementById('product__description-show-more');
  if (prodDescLoadMore) {
    prodDescLoadMore.addEventListener('click', (event) => {
      let descEl = document.querySelector('.product__description--collapsed');
      if(descEl) {
        descEl.classList.toggle('product__description--collapsed');
      }
      prodDescLoadMore.parentElement.classList.toggle('product__description-show-more--hidden');
      prodDescLoadMore.parentElement?.parentElement.classList.toggle('product__description-wrap--open');
    });
  }
}
prodDescShowMoreBtn();

subscribe(PUB_SUB_EVENTS.variantChange, ()=> {
  prodDescShowMoreBtn();
});

// Fake Select element for variant buttons used on mobile views
document.querySelectorAll('.product-form__input .fake-select-btn').forEach((el) => {
  el.addEventListener('click', (e) => {
    e.preventDefault();
    let fakeSelect = e.target.nextElementSibling;
    if(fakeSelect && fakeSelect.classList.contains('fake-select')) {
      fakeSelect.classList.toggle('fake-select--open');
    }
  });
});
document.querySelectorAll('.product-form__input .fake-select input[type=radio]+label').forEach((el) => {
  el.addEventListener('click', (e) => {
    let fakeSelect = e.target.parentElement;
    let fakeSelectBtn = e.target.parentElement?.parentElement?.querySelector('.fake-select-btn span');
    if(fakeSelect && fakeSelect.classList.contains('fake-select--open')) {
      fakeSelect.classList.remove('fake-select--open');
    }
    if(fakeSelectBtn && e.target.innerText) {
      fakeSelectBtn.innerText = e.target.innerText;
    }
  });
});

// Replacement parts section ATC functionality
document.querySelectorAll('.product-replacement-parts__form').forEach((form) => {
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(form);
    if (cart) {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
          return;
        } else if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }
        cart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      });
  });
})




function searchPanels(e) {
  let controlItems = document.querySelectorAll('.aa-PanelSections__nav-item');
  if(controlItems) {
    controlItems.forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        item.classList.remove('active');
        let controls = e.target.getAttribute('aria-controls');
        let controledItem = document.getElementById(`#${controls}`);
        if(controledItem) {
          document.querySelectorAll('.aa-PanelSections__tab-content').forEach(function(item) {
            item.style.display = 'none'
          });
          e.target.classList.add('active');
          controledItem.style.display = 'block';
        }
      });
    })
  }
}


document.querySelectorAll('.product-replacement-parts__button:not(.product-replacement-parts__button--algolia)').forEach(item => {
  item.addEventListener('click', ev => {
    ev.preventDefault();
    item.parentNode.querySelector('.product-replacement-parts__grid').classList.toggle('active')
    item.classList.toggle('hidden')
  });
});

let layoutSwitch = document.querySelector('#layout-switch');
if(layoutSwitch) {
  layoutSwitch.addEventListener('click', function(e) {
    e.preventDefault();
    document.body.classList.toggle('isgrid');
  });
}

/** Click algolia clear button on search modal close */
const smCloseBtn = document.querySelector('.search-modal__close-button');
if(smCloseBtn) {
  smCloseBtn.addEventListener('click', function() {
    let aaClear = document.querySelector('.aa-ClearButton');
    if(aaClear) {
      aaClear.click();
    }
  });
}



// PArts page sticky ATC
let buyButtonsWrap = document.querySelector('.buy-buttons-wrap');
const mobileViewSize = window.matchMedia('(max-width: 767px)')
if(buyButtonsWrap && mobileViewSize.matches && document.body.classList.contains('parts')) {

  function isElementInBottomViewport(el) {
    var rect = el.getBoundingClientRect();
    var elemBottom = rect.bottom;
    var isVisible = elemBottom <= window.innerHeight;
    return isVisible;
  }
  
  function handleScroll() {
    const elementInView = isElementInBottomViewport(buyButtonsWrap);
    if (elementInView) {
      // Element has entered the viewport
      buyButtonsWrap.classList.add('buy-button-sticky');
      document.body.classList.add('hasStickyAtc');
    } else {
      // Element has left the viewport
      buyButtonsWrap.classList.remove('buy-button-sticky');
      document.body.classList.remove('hasStickyAtc');
    }
  }
  document.addEventListener("DOMContentLoaded", function(event) {
      handleScroll();
  });
  window.addEventListener('scroll', handleScroll);
}

// Collection list page 
// Uses delta.is_hidden metafield to hid collection from showing on list of collections
document.addEventListener("DOMContentLoaded", function(event) {
  const collectionsEl = document.getElementById('ccollection');
  if(!collectionsEl) {
    return;
  }
  (function(algolia) {
    const algoliasearch = algolia.externals.algoliasearch;
    const instantsearch = algolia.externals.instantsearch;
    const hits = algolia.externals.widgets.hits;
    const pagination = algolia.externals.widgets.pagination;
    const configure = algolia.externals.widgets.configure;

    const searchClient = algoliasearch(
    algolia.config.app_id,
    algolia.config.search_api_key
    );
    const search = instantsearch({
      searchClient: searchClient,
      indexName: algolia.config.index_prefix + "collections",
      searchFunction: function(searchFunctionHelper) {
        var page = searchFunctionHelper.getPage();
  
        searchFunctionHelper.setQueryParameter(
          'facetFilters',
          'meta.delta.is_hidden:-true'
        );

        searchFunctionHelper.setPage(page);
        searchFunctionHelper.search();
      },
    });

    search.addWidgets([
      configure({
        hitsPerPage: 30,
      }),
    ]);

    search.addWidgets([
      hits({
        container: collectionsEl,
        templates: {
          item(hit, {html, components}) {
            return algolia.instantSearchCollectionCustomTemplate(hit, html, components);
          },
          empty(results, {html}) {
            return algolia.instantSearchNoResultTemplate(html);
          }
        },
        cssClasses: {
          item: ['collection-list__item', 'grid__item'],
          list: ['collection-list ', 'grid', 'grid--3-col-desktop', 'grid--2-col-tablet-down'],
        },
      })
    ]);

    search.addWidgets([
      pagination({
        container: '.ais-pagination-container',
        padding: 2,
        maxPages: 20,
        showFirst: false,
        showLast: false,
        cssClasses: {
          list: ['pagination__list', 'list-unstyled'],
          root: ['pagination'],
          nextPageItem: ['pagination__item-link', 'pagination__item-link--next', 'pagination__item-link-arrow', 'link', 'motion-reduce'],
          previousPageItem: ['pagination__item-link', 'pagination__item-link--prev', 'pagination__item-link-arrow', 'link', 'motion-reduce'],
          link: ['pagination__item', 'link'],
          selectedItem: ['pagination__item-link', 'pagination__item-link--current', 'light'],
        },
        templates: {
          previous: 'Previous',
          next: 'Next'
        }
      }),
    ]);
  
    search.start();

    })(window.algoliaShopify);
});

if(document.querySelector('.product-variant-id')) {
  document.querySelector('.product-variant-id').addEventListener('change', (e) => {
    let varId = e.target.value;

    let target = document.querySelector('.model-number-container .model-number[data-variant-id="'+varId+'"]');
    if(target) {
      document.querySelectorAll('.model-number-container .model-number').forEach(el => {
        el.classList.add('hidden');
      });
      target.classList.remove('hidden');
    }
  });
}

// Product page color variant image switcher
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-color-variants__img').forEach(function(image) {
    image.addEventListener('click', function(event) {
      const newImageHtml = event.target.getAttribute('data-variant-image');
      const productItem = event.target.closest('.grid__item');
      const mediaContainer = productItem.querySelector('.media');

      if (newImageHtml && mediaContainer) {
        mediaContainer.innerHTML = newImageHtml;
      }

      // Update active class
      const variantImages = event.target.closest('.product-color-variants').querySelectorAll('.product-color-variants__img');
      variantImages.forEach(function(variantImg) {
        variantImg.classList.remove('active');
      });
      event.target.classList.add('active');
    });
  });
});


// Banner button click to scroll to video and play video
document.addEventListener('DOMContentLoaded', function() {
  let playVideoLink = document.querySelector('.banner__buttons a[href^="#Deferred-Poster-Modal"]');
  if(playVideoLink) {
    playVideoLink.addEventListener('click', function(e) {
      e.preventDefault();
      let urlHash = e.target?.hash;
      if(urlHash) {
        if (urlHash.startsWith('#')) {
          urlHash = urlHash.substring(1);
        }
        let videoWrap = document.getElementById(urlHash);
        if(videoWrap) {
          videoWrap.scrollIntoView({ behavior: 'smooth', block: "center" });
          setTimeout(function() {
            videoWrap.click();
          }, 800);  
        }
      }
    });
  }
});

// Attach click event listener to Price Spider widget buttons
function delta_pricespider_click_events() {
  const container = document.querySelector('.ps-widget'); 

  if(!container) {
    return;
  }

  function attachClick(button) {
    button.addEventListener('click', (e) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'google_ads_conversion1',
        interaction_source: 'pricespider'
      });
    });
  }

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1) { 
          if (node.tagName === 'BUTTON' || node.classList.contains('ps-last-online-seller-details-wrapper')) {
            attachClick(node);
          }

          const buttons = node.querySelectorAll && node.querySelectorAll('button, .ps-last-online-seller-details-wrapper');
          if (buttons && buttons.length) {
            buttons.forEach(attachClick);
          }
        }
      }
    }
  });

  observer.observe(container, { childList: true, subtree: true });
}
delta_pricespider_click_events();
